import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { Variable } from "../models/formulas/variable";
import { FilterVariableCatalog } from "../models/filters/filter-variable-catalog";

@Injectable({
  providedIn: 'root'
})
export class VariableCatalogService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/variablesCatalog'; 

  findAllPageableVariableCatalog(filterVariableCatalog: FilterVariableCatalog, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterVariableCatalog);
  }

  findVariableCatalogById(id: number): Observable<Variable> {
    return this.http.get<Variable>(`${this.url}/${id}`);
  }

  createVariableCatalog(variable: Variable): Observable<Variable>{
    return this.http.post<Variable>(this.url, variable);
  }

  updateVariableCatalog(variable: Variable): Observable<Variable>{
    return this.http.put<Variable>(`${this.url}/${variable.id}`, variable);
  }

}